import { Fragment } from "react";
import {
  Modal,
  ModalHeader,
  Form,
  ModalBody,
  Input,
  Label,
  Row,
  Col,
  FormFeedback,
} from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast, ToastContainer } from "react-toastify";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { createChat } from "api/mutators/chat";


const defaultValues = {
  title: "",
};

const ChatModal = (props: any) => {
  const { t } = useTranslation("translation", { keyPrefix: "CHAT" });

  const schema = yup.object().shape({
    title: yup.string().required(t("ERRORS:TITLE")),
  });

  const { modal, toggle, setModal, refetchFiles, folderId, setChatId, setBox } = props;

  const {
    reset,
    control,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues,
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: createChat,
    onError: (error: any) => {
      queryClient.invalidateQueries({
        queryKey: ["fetchLastChats"],
      });
      toast.error("Error! Chat not created", { autoClose: 3000 });
    },
    onSuccess: (data: any) => {
      
      console.log("Chat created successfully", data);
      setChatId(data.data.id);
      setBox("Agente AI Care - " + data.data.title);
      setModal(false);
      reset(defaultValues);
      refetchFiles();
      queryClient.invalidateQueries({
        queryKey: ["fetchLastChats"],
      });
      toast.success("Chat Created Successfully", { autoClose: 3000 });
    },
  });

  function onSubmit() {
    mutation.mutate({ ...getValues(), parentFolderId: folderId });
  }

  return (
    <Fragment>
      <Modal id="showModal" size={"xl"} isOpen={modal} toggle={toggle} centered>
        <ModalHeader className="bg-light p-3" toggle={toggle}>
          {t("MODALS:CREATE")}
        </ModalHeader>
        <Form className="tablelist-form" onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <>
              <Row>
                <Col>
                  <div className="mb-3 pb-2">
                    <Label className="form-label" for="title">
                      {t("MODALS:TITLE")}
                    </Label>
                    <Controller
                      control={control}
                      name="title"
                      render={({ field }) => (
                        <Input
                          {...field}
                          id="title"
                          placeholder={t("MODALS:TITLE")}
                          invalid={!!errors.title}
                        />
                      )}
                    />
                    {errors.title && (
                      <FormFeedback>{errors.title.message}</FormFeedback>
                    )}
                  </div>
                </Col>
              </Row>
            </>
          </ModalBody>
          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  reset(defaultValues);
                  setModal(false);
                }}
              >
                {t("MODALS:CLOSE")}
              </button>
              <button type="submit" className="btn btn-soft-danger">
                {t("MODALS:SAVE")}
              </button>
            </div>
          </div>
        </Form>
      </Modal>
      <ToastContainer closeButton={false} limit={1} />
    </Fragment>
  );
};

export default ChatModal;
